var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCommitEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_commit_edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.59159708,8.47167035 C4.46946764,8.34805004 4.46946764,8.14201619 4.59159708,8.01839588 L5.03940501,7.56512141 C5.16153445,7.4415011 5.36508351,7.4415011 5.48721294,7.56512141 L8.01122129,10.1405445 C8.09264092,10.2229581 8.23512526,10.2229581 8.31654489,10.1405445 L13.2627871,5.09271523 C13.3849165,4.96909492 13.5884656,4.96909492 13.710595,5.09271523 L14.1584029,5.5459897 C14.2805324,5.66961001 14.2805324,5.87564386 14.1584029,5.99926416 L8.39796451,11.8918322 C8.27583507,12.0360559 8.07228601,12.0360559 7.95015658,11.8918322 L4.59159708,8.47167035 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_commit_edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "checkbox_checked-copy-2",
    fill: "#005082",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-2",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommitEdit);
export default __webpack_public_path__ + "static/media/icon_commit_edit.757b94e69f1e1b2c4bfd5c98ed93d761.svg";
export { ForwardRef as ReactComponent };